<template>
  <b-modal id="gallery-modal" centered size="large" hide-header hide-footer>
    <div class="gallery-modal px-1">
      <div class="gallery-modal__header">
        <a href="#">
          <inline-svg
            :src="require('@/assets/images/icons/dashboard/folder-add.svg')"
          />
          مكتبة وسائط المتجر
        </a>
        <a href="#" class="orange-link">
          <inline-svg
            :src="require('@/assets/images/icons/dashboard/folder-add.svg')"
          />
          مكتبتي الخاصة
        </a>
      </div>
      <div class="dashboard-filter__select">
        <b-form-select :value="null" :options="options" />
      </div>
      <VuePerfectScrollbar class="gallery-list">
        <div
          v-for="(image, index) in gallery"
          :key="index"
          class="gallery-list__item"
        >
          <img
            :src="`https://picsum.photos/100/100?random=${image}`"
            width="200"
            class="gallery-list__item__img"
          />
          <span
            class="gallery-list__item__icon"
            @click="gallery.splice(index, 1)"
          >
            <feather-icon icon="XIcon" />
          </span>
        </div>
      </VuePerfectScrollbar>
      <div class="row pt-2 mt-1">
        <div class="col-md-6 mb-2">
          <b-input-group>
            <b-input-group-prepend is-text>
              <feather-icon size="22" icon="PlayCircleIcon" />
            </b-input-group-prepend>
            <b-form-select :value="null" :options="options" />
            <b-input-group-append is-text>
              <feather-icon size="22" icon="RefreshCcwIcon" />
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-md-6 mb-2">
          <b-input-group>
            <b-form-input placeholder="أضف اسم للرابط" />
            <b-input-group-append is-text> اختياري </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-12">
          <b-form-tags
            v-model="tags"
            class="mb-2 py-1"
            placeholder="أضف نص دلالي لمحركات البحث"
            addButtonText="اضافة"
          />
        </div>
      </div>
      <div class="modal-actions">
        <button class="btn px-4 btn--gradient-green" @click="hideModal">
          حفظ
        </button>
        <button class="btn px-4 btn--gray ml-1" @click="hideModal">
          الغاء
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormSelect,
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTags,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
export default {
  name: "ProductsGalleryModal",
  components: {
    BModal,
    BFormSelect,
    BInputGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTags,
    VuePerfectScrollbar,
  },
  data() {
    return {
      options: [
        { value: null, text: "اختر النوع", disabled: true },
        { value: "a", text: "option 1" },
        { value: "b", text: "option 2" },
      ],
      tags: [],
      gallery: [],
    };
  },
  methods: {
    hideModal() {
      this.$bvModal.hide("gallery-modal");
    },
  },
  created() {
    for (let i = 1; i <= 50; i++) {
      this.gallery.push(`https://picsum.photos/100/100?random=${i}`);
    }
  },
};
</script>
